<template>
  <div v-if="richText">
    <RichTextVueParser v-bind="props" :h2-style :richText :style-variant />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { RichText } from '@backmarket/http-api/src/api-specs-content/models/rich-text'
import type { RichTextProps } from '@backmarket/http-api/src/api-specs-content/models/rich-text-content'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { isEmpty } from '@backmarket/utils/object/isEmpty'

import type { ContentBlockProps } from '../../models/content-block'

import { parseRichText } from './DynamicTextDates.utils'
import RichTextVueParser from './RichTextVueParser.vue'

const props = withDefaults(defineProps<RichTextProps & ContentBlockProps>(), {
  lightText: false,
  ignoreLinks: false,
  styleVariant: 'default',
  h2Style: undefined,
})

const locale = useI18nLocale()

const richText = computed(() => {
  if (isEmpty(props.richText)) return null

  return parseRichText(props.richText as RichText, locale)
})

// This event is common to every CMS block in order to hide the block containers
// on demand
defineEmits(['error'])
</script>
